<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <div class="header-user">
        <div>
          <p>Hola {{ userName }}</p>
        </div>
        <div>
          <figure>
            <img
              :src="userAvatar"
              class="img-avatar"
              :alt="userName" />
          </figure>
        </div>
      </div>
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center">
        <strong>Cuenta</strong>
      </b-dropdown-header>
      <b-dropdown-item  @click.stop="perfil()"><i class="fa fa-user"/> Perfil</b-dropdown-item>
      <b-dropdown-item @click.prevent="pass" ><i class="fa fa-key" /> Password</b-dropdown-item>
      <b-dropdown-item v-if="opcionEvaluaciones" @click.prevent="evaluaciones" ><i class="fa fa-external-link" /> Evaluaciones</b-dropdown-item>
      <b-dropdown-item @click.prevent="procesosGenerales" ><i class="fa fa-external-link" /> Procesos Generales</b-dropdown-item>
      <!--<b-dropdown-item><i class="fa fa-wrench" /> Configuraciones</b-dropdown-item>-->
      <b-dropdown-item @click.prevent="logout" ><i class="fa fa-lock" /> Salir</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import moment from 'moment'

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { 
      opcionEvaluaciones: true,
    }
  },
  computed: {
    userName: function() {
      return this.camelize(this.$store.getters['user/nombre']);
    },
    userAvatar: function () {
      let server = process.env.VUE_APP_ROOT_API;
      let avatar = server + '/img/avatars/man.png';
      
      let userAvatar = this.$store.getters['user/avatar'].trim();
      let userAvatarExtension = this.$store.getters['user/avatarExtension'].trim();
      if (userAvatar) {
        if (userAvatar.trim() != '') {
          avatar = `data:image/${userAvatarExtension};base64,${userAvatar}`;
        }
      }
      
      return avatar;
    }
  },
  created() {
  },
  methods: {
    logout (){
      /* Logout del usuario */  
      this.$store.dispatch('user/logout');

      this.$router.push({ name: 'Login' })
    },
    perfil(){
      if (this.$store.getters['user/loggedIn'] ) {
        this.$router.push({ name: 'UsuarioPerfil' }); 
      }
    },
    pass() {
      this.$router.push({ name: 'UsuarioSelfPass' });
    },
    evaluaciones(){
      if (this.$store.getters['user/loggedIn'] ) {
        /* userId -> Base64 */
        let key= `[{\"userId\":${this.$store.getters['user/userId'].toString().trim()},\"dateTime\":\"${moment(new Date()).format('YYYYMMDDHHmm')}\"}]`;
        // console.log(key);
        window.open(`https://evaluaciones.cervetti.com.ar/${btoa(key)}`, "_blank");	
      }
    },
    procesosGenerales(){
      if (this.$store.getters['user/loggedIn'] ) {
        window.open(`https://view.genial.ly/6400e90921599100138daf3b`, "_blank");	
      }
    },
  } 
}
</script>

<style>
</style>
